import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { findFirst } from "../../../../utils/arrays";
import { Singleton } from "../../../../utils/singleton";
import { isLowerCaseEquals } from "../../../../utils/strings";
import { ERegisterStatus } from "../constants";
var TransactionState = /*#__PURE__*/function (_Singleton) {
  function TransactionState() {
    _classCallCheck(this, TransactionState);
    return _callSuper(this, TransactionState, [{}]);
  }
  _inherits(TransactionState, _Singleton);
  return _createClass(TransactionState);
}(Singleton);
export var getTransactionState = function getTransactionState() {
  return TransactionState.getInstance().getData();
};
export var setTransactionState = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, status) {
    var _findFirst;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", TransactionState.getInstance().initialize((_findFirst = findFirst([status && isLowerCaseEquals(status, ERegisterStatus.SmsCode) && data, status && isLowerCaseEquals(status, ERegisterStatus.IncorrectSmsCode) && data])) !== null && _findFirst !== void 0 ? _findFirst : {}));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function setTransactionState(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();